import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Subject} from 'rxjs';
import { LoadingGenericoComponent } from '../loading-generico/loading-generico.component';

@Component({
    selector: 'app-chat-bot',
    templateUrl: './chat-bot.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LoadingGenericoComponent]
})
export class ChatBotComponent implements OnInit, OnDestroy {

  public loadingGenerico: any = false;
  public destroyed$ = new Subject<void>();

  public injectScript() {
    const script = `
    (function () {
      window.VI_API = {};
      window.VI_API.license = 'VI-88888792-1';
      window.VI_API.source = 21;
      window.VI_API.eyeCatcher = 1;
      window.VI_API.launchType = 'embedded';
      window.VI_API.customVars = [
        { 'name': 'nome', 'value': '${localStorage.nomeFantasia}' },
        { 'name': 'razaoSocial', 'value': '${localStorage.nomeEmpresa}' },
        { 'name': 'cnpj', 'value': '${localStorage.cnpj}' }
      ];
      (function () {
        var vi = document.createElement('script');
        vi.type = 'text/javascript';
        vi.async = true;
        vi.src = "${sessionStorage.urlChatBot}" + '?ms=' + new Date().getTime();
        var vis = document.getElementsByTagName('script')[0];
        vis.parentNode.insertBefore(vi, vis);
      })();
    }())
    `;
    const scriptElement = document.createElement('script');
    scriptElement.innerHTML = script;
    document.body.appendChild(scriptElement);
  }

  ngOnInit(): void {
    this.loadingGenerico = true;

    this.injectScript();

    this.loadingGenerico = false;
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
